import { createRouter, createWebHistory } from 'vue-router';
import { getToken } from '@/api';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: { title: '登录' },
    },
    {
      path: '/',
      component: () => import('@/layouts/MainLayout.vue'),
      redirect: '/dashboard',
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('@/views/Dashboard.vue'),
          meta: { title: '数据看板', icon: 'DataAnalysis' },
        },
        {
          path: '/items',
          name: 'items',
          component: () => import('@/views/Items.vue'),
          meta: { title: '事项', icon: 'List' },
        },
        {
          path: '/items/:id',
          name: 'item-detail',
          component: () => import('@/views/ItemDetail.vue'),
          meta: { title: '事项详情', hidden: true },
        },
        {
          path: '/tags',
          name: 'tags',
          component: () => import('@/views/Tags.vue'),
          meta: { title: '标签管理', icon: 'CollectionTag' },
        },
      ],
    },
  ],
});

router.beforeEach((to, _from, next) => {
  const token = getToken();
  // 未登录访问受保护页 → 跳登录
  if (!token && to.name !== 'login') return next({ name: 'login' });
  // 已登录访问登录页 → 跳看板
  if (token && to.name === 'login') return next({ name: 'dashboard' });

  if (to.meta.title) {
    document.title = `${to.meta.title} · 电萌协同 PC`;
  }
  next();
});

export default router;